import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

/* eslint-disable max-classes-per-file */
export var PropInfoError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PropInfoError, _Error);

  function PropInfoError() {
    return _Error.apply(this, arguments) || this;
  }

  return PropInfoError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var PropInfoCollisionError = /*#__PURE__*/function (_PropInfoError) {
  _inheritsLoose(PropInfoCollisionError, _PropInfoError);

  function PropInfoCollisionError() {
    return _PropInfoError.apply(this, arguments) || this;
  }

  return PropInfoCollisionError;
}(PropInfoError);